import { useState } from 'react';
import ADEntitiesSelector from '../Modals/ADEntitiesSelector/ADEntitiesSelector';
import { SELECTOR_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import Filters from './Filters';
import {
    AD_ENTITIES_AND_LOCAL_ACCOUNTS,
    DEVICES,
    DEVICES_ONLY,
    ENTITIES,
    SERVERS,
    SERVERS_ONLY,
    USERS
} from './externalFilterTypes';
import CustomFilters from '../../Logs/CustomFilters';

const FiltersMenu = ({
    filters,
    darkMode,
    openOnTop,
    onValueChange,
    customStyles,
    entitiesSelectorConfig = [],
    customFiltersConfig,
    closeAllFilters,
    newDesign
}) => {
    const [showSelectEntitiesModal, setShowSelectEntitiesModal] = useState(false);
    const [activeFilter, setActiveFilter] = useState();

    const handleEntitiesFilter = (filter) => {
        setActiveFilter(filter);
        setShowSelectEntitiesModal(true);
    };

    const handlers = {
        [ENTITIES]: handleEntitiesFilter,
        [DEVICES_ONLY]: handleEntitiesFilter,
        [SERVERS]: handleEntitiesFilter,
        [SERVERS_ONLY]: handleEntitiesFilter,
        [USERS]: handleEntitiesFilter,
        [DEVICES]: handleEntitiesFilter,
        [AD_ENTITIES_AND_LOCAL_ACCOUNTS]: handleEntitiesFilter
    };

    const selectEntitiesHandler = (selectedEntities) => {
        setShowSelectEntitiesModal(false);
        onValueChange(activeFilter.id, selectedEntities, activeFilter.isExcluded);
    };

    return (
        <div style={customStyles}>
            <div className={'flex flex-row justify-between'}>
                <Filters
                    newDesign={newDesign}
                    filters={filters}
                    darkMode={darkMode}
                    onValueChange={onValueChange}
                    externalHandlers={handlers}
                    openOnTop={openOnTop}
                    closeAllFilters={closeAllFilters}
                />

                {customFiltersConfig && <CustomFilters {...customFiltersConfig} />}
            </div>
            {showSelectEntitiesModal && activeFilter && (
                <ADEntitiesSelector
                    selectedObjectEntities={activeFilter.externalSelections?.entities || []}
                    selectedUnmanagedEntities={activeFilter.externalSelections?.unmanagedEntities || []}
                    selectedIpEntities={activeFilter.externalSelections?.ipEntities || []}
                    selectedApplicationEntities={activeFilter.externalSelections?.applicationEntities || []}
                    selectorType={SELECTOR_TYPES[activeFilter.externalFilterType]}
                    showModal={showSelectEntitiesModal}
                    handleCloseModal={() => setShowSelectEntitiesModal(false)}
                    saveEntities={selectEntitiesHandler}
                    allowApplications={activeFilter.allowApplications}
                    {...entitiesSelectorConfig[activeFilter.externalFilterType]}
                />
            )}
        </div>
    );
};

export default FiltersMenu;
